import React from 'react'
import { ShimmerText , ShimmerTitle ,ShimmerThumbnail } from "react-shimmer-effects";

const Shimmer = () => {
  return (
    <div>
        <div className='rounded-xl'>
          <div className='hidden md:block'>
              <ShimmerThumbnail height={60} className={["w-full","mx-auto "]}  />
          </div>
          <div className='block md:hidden'>
              <ShimmerThumbnail height={150} className={["w-full","mx-auto "]}  />
          </div>
        </div>
        <div className="container mt-5  md:container max-w-[95%] md:max-w-[90%] mx-auto rounded-xl overflow-hidden">
          <div className='hidden md:block'>
                <ShimmerThumbnail  className={[]} height={500}  rounded />
          </div>
          <div className='block md:hidden'>
                <ShimmerThumbnail  className={[]} height={200}  rounded />
          </div>
        </div>

        <div className='container mt-10  md:mt-24  md:container max-w-[95%] md:max-w-[90%] mx-auto rounded-xl overflow-hidden'>
              <div className='w-full grid grid-cols-2 md:grid-cols-4 gap-2'>
                  <ShimmerThumbnail  className={["w-full","mx-auto"]} rounded />
                  <ShimmerThumbnail  className={["w-full","mx-auto"]} rounded />
                  <ShimmerThumbnail  className={["w-full","mx-auto"]} rounded />
                  <ShimmerThumbnail  className={["w-full","mx-auto"]} rounded />
              </div>
        </div>
    </div>
  )
}

export default Shimmer;